import { render, staticRenderFns } from "./_project.vue?vue&type=template&id=4a03b87d&"
import script from "./_project.vue?vue&type=script&lang=ts&"
export * from "./_project.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Thermotech\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a03b87d')) {
      api.createRecord('4a03b87d', component.options)
    } else {
      api.reload('4a03b87d', component.options)
    }
    module.hot.accept("./_project.vue?vue&type=template&id=4a03b87d&", function () {
      api.rerender('4a03b87d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Dev/js/components/mypages/nemesys/_project.vue"
export default component.exports